import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type { IncidentTransactionsResponse } from '../../features/variance-tracker/components/variance-supporting-data/models/incident-transactions-response.model';

export interface IncidentTransactionsClient {
  getTransactions(incidentNumber: string, organizationId: string): Observable<IncidentTransactionsResponse>;
}

export const INCIDENT_TRANSACTIONS_CLIENT = new InjectionToken<IncidentTransactionsClient>('INCIDENT_TRANSACTIONS_CLIENT');
